export default "__VITE_ASSET__d2a01bc1__$_?react__"